/**
 * A field's error message, in the error text color, for the field to name in
 * `aria-describedby`. An alert, so a message that appears while focus is in the field is heard.
 */
export function FieldError(props: { readonly id: string; readonly message: string }) {
  return (
    <p id={props.id} role="alert" className="text-xs text-error-text">
      {props.message}
    </p>
  )
}
